module.exports = __webpack_public_path__ + "img/btn1.190aaf6b.png";